import { render, staticRenderFns } from "./HomePageWidgetSlider.vue?vue&type=template&id=29b33c3c"
import script from "./HomePageWidgetSlider.vue?vue&type=script&lang=ts"
export * from "./HomePageWidgetSlider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports